import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { getDailyCloseProductHeads, getDailyCloseProductItems } from './apis'
import type { DailyCloseProductHead, DailyCloseProductItem, DailyCloseProductItemSearch, DailyCloseProductSearch } from './types'

const PATH = ['RP12', 'INVENTORY', 'DAILY_CLOSE_PRODUCT'] as const

export const dailyCloseProductQueryKeys = {
  all: PATH,
  heads: (params: DailyCloseProductSearch | null, requestSequence: number) => [...PATH, 'HEADS', params, requestSequence] as const,
  items: (params: DailyCloseProductItemSearch | null) => [...PATH, 'ITEMS', params] as const,
}

export const useGetDailyCloseProductHeads = (
  params: DailyCloseProductSearch | null,
  requestSequence: number,
): UseQueryResult<DailyCloseProductHead[], Error> =>
  useQuery({
    meta: { errorToast: true },
    queryKey: dailyCloseProductQueryKeys.heads(params, requestSequence),
    queryFn: async () => {
      if (!params) throw new Error('일마감 헤더 조회 조건이 없습니다.')
      return (await getDailyCloseProductHeads(params)).data.items
    },
    enabled: params != null,
  })

export const useGetDailyCloseProductItems = (params: DailyCloseProductItemSearch | null): UseQueryResult<ApiPageResponse<DailyCloseProductItem>, Error> =>
  useQuery({
    meta: { errorToast: true },
    queryKey: dailyCloseProductQueryKeys.items(params),
    queryFn: async () => {
      if (!params) throw new Error('일마감 상세 조회 조건이 없습니다.')
      return (await getDailyCloseProductItems(params)).data
    },
    enabled: params != null,
  })
